import React, { useEffect } from "react";
import AllRoutes from "./Routes/AllRoutes";
import { ToastContainer } from "react-toastify";
import "./index.css";
import useWebSocket from "./socket";

function App() {
  const { messages, isConnected, sendMessage } = useWebSocket('wss://certvalue.training:3001/ws');

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();

       // Disable Ctrl + Shift + C
       const disableDevToolsShortcut = (e) => {
        if (e.ctrlKey && e.shiftKey && e.code === "KeyC") {
          e.preventDefault();
          alert("This action is disabled!");
        }
      };

    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener("keydown", disableDevToolsShortcut);


    // Cleanup to remove the event listener on unmount
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener("keydown", disableDevToolsShortcut);

    };
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <AllRoutes />
    </div>
  );
}

export default App;
